<template>
  <div class="container">
    <el-dialog
      :title="title"
      :custom-class="isMinWidth?'custom-dialog custom-dialog-min-width-800':'custom-dialog'"
      :visible.sync="dialogShow"
      :width="width"
      :top="top"
      :close-on-click-modal="false"
      @close="$emit('dialogClose')"
      @open="$emit('dialogOpen')"
    >
      <div
        v-loading="loading.show"
        :element-loading-text="loading.text"
        class="dialog-content"
      >
        <slot></slot>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "custom_dialog",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: "70%"
    },
    isMinWidth: {
      type: Boolean,
      default: true
    },
    top: {
      type: String,
      default: "5vh"
    },
    loading: {
      type: Object,
      default: () => {
        return {
          show: false,
          text: ""
        };
      }
    },
    title: String
  },
  data() {
    return {};
  },
  computed: {
    dialogShow: {
      get() {
        return this.show;
      },
      set(newValue) {
        this.$emit("update:show", newValue);
      }
    }
  }
};
</script>
<style lang="scss">
.custom-dialog {
  .el-dialog__header {
    border-bottom: 1px solid #e8eaec;
    .el-dialog__title {
      line-height: 15px;
      font-size: 15px;
      font-weight: bold;
      color: #303133;
    }
  }
  .el-dialog__body {
    padding: 10px 20px !important;
  }
}

.custom-dialog-min-width-800 {
  min-width: 800px;
}
</style>